export default {
  en: {
    'components.conversion-settings-form.default-text': 'In my sheet',
    'components.conversion-settings-form.named-field.required': '{name} is required',
    'components.conversion-settings-form.column-letter.error.unique':
      'Column letter: {letter} has already been used. Please select an unused column.',
    'components.conversion-settings-form.column-letter.error.type-case':
      'Column reference must be an uppercase letter (A-Z)',
    'components.conversion-settings-form.mapping-name.required': 'Mapping name is required',
    'components.conversion-settings-form.data-start-row.required': 'Data start row is required',
    'components.conversion-settings-form.data-mapping.header': 'Data mapping',
    'components.conversion-settings-form.mapping-settings.header': 'Mapping settings',
    'components.conversion-settings-form.filing-data.header': 'Filing Data Fields',
    'components.conversion-settings-form.data-source.header': 'Data Source',
  },
};
